<template>
  <div class="relative w-full" @focusout="closeList">
    <ais-search-box class="flex relative w-full justify-end flex-row pb-1">
      <template #default="{ currentRefinement, refine }">
        <div class="flex flex-grow w-[60%] relative font-normal font-montserrat">
          <input
            :value="currentRefinement"
            :maxlength="MAX_ALLOWED_LENGTH"
            type="text"
            class="font-montserrat font-bold text-base text-university-primary leading-5 py-1 pl-[52px] pr-[16px] border border-gray-475 rounded-full h-10 w-full placeholder-university-primary placeholder-opacity-50"
            placeholder="SEARCH"
            autocomplete="off"
            @input="refine($event.currentTarget.value)"
            @click="showList = true"
            @keydown.arrow-down.prevent="moveDown"
            @keydown.arrow-up.prevent="moveUp"
            @keydown.enter.prevent="handleItemSelect"
            @keydown.esc.prevent="closeList"
          />
          <CustomSearchIcon size="20" stroke="#007f80" class="self-center absolute left-[16px]" />
        </div>
      </template>
    </ais-search-box>
    <div v-if="showList" class="absolute border border-transparent rounded-lg shadow-lg w-full bg-white">
      <div v-if="isMobile" class="font-montserrat text-sm text-university-primary bg-gray-200 rounded-t-lg p-2 w-full">
        <span class="font-bold">Touch</span> to select. <span class="font-bold">Touch</span> anywhere else to dismiss
      </div>
      <div v-else class="font-montserrat text-sm text-university-primary bg-gray-200 rounded-t-lg p-2 w-full">
        Press <span class="font-bold">enter</span> to select, <span class="font-bold">↑ ↓</span> to navigate,
        <span class="font-bold">esc</span> to dismiss
      </div>
      <ais-hits>
        <template #default="{ items }">
          <div class="divide-y divide-gray-475 px-3 pb-1">
            <template v-if="items.length > 0">
              <div
                v-for="(item, index) in groupItems(items)"
                :key="index"
                class="font-montserrat font-475 text-sm text-university-primary py-3 text-pretty truncate"
                :class="[selectedIndex === index ? 'bg-blue-350' : 'hover:bg-blue-350']"
                @mouseover="selectedIndex = index"
              >
                <router-link :to="itemRoute(item)">
                  {{ item.student.first_name_legal }} {{ item.student.last_name }} - {{ item.student.email }}
                </router-link>
              </div>
            </template>
            <template v-else>
              <span>No Results</span>
            </template>
          </div>
        </template>
      </ais-hits>
    </div>
  </div>
</template>
<script setup>
import { AisSearchBox, AisHits } from "vue-instantsearch/vue3/es";
import CustomSearchIcon from "@/components/svg-icons/CustomSearchIcon.vue";
import { useMediaQuery } from "@vueuse/core";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

const props = defineProps({
  itemsLimit: {
    type: Number,
    default: 5,
  },
});

const route = useRoute();
const router = useRouter();
const MAX_ALLOWED_LENGTH = 512;
const showList = ref(false);
const selectedIndex = ref(-1);
const itemRefs = ref([]);

const isMobile = useMediaQuery("(max-width: 768px)");

const groupItems = (items) => {
  const groupedList = [];
  for (const item of items) {
    const skipItem = groupedList.find(
      (listedItem) => item.student.participant_id === listedItem.student.participant_id
    );
    if (groupedList.length === props.itemsLimit) {
      break;
    }
    if (!skipItem) {
      groupedList.push(item);
    }
  }
  itemRefs.value = groupedList;
  return groupedList;
};

const itemRoute = (item) => ({
  name: "student-management",
  query: route.query,
  params: { page: "student-detail", oktaId: item.student.participant_id },
});

const closeList = () => {
  setTimeout(() => {
    showList.value = false;
    selectedIndex.value = -1;
  }, 250);
};

const handleItemSelect = () => {
  if (selectedIndex.value < 0) return;
  router.push(itemRoute(itemRefs.value[selectedIndex.value]));
};

const moveUp = () => {
  const total = itemRefs.value.length;
  if (total === 0) return;
  selectedIndex.value = selectedIndex.value > 0 ? selectedIndex.value - 1 : total - 1;
};

const moveDown = () => {
  const total = itemRefs.value.length;
  if (total === 0) return;
  selectedIndex.value = selectedIndex.value < total - 1 ? selectedIndex.value + 1 : 0;
};
</script>
